import styled from "styled-components";
import dragonSrc from "assets/images/dragon.png";
import dragonHoverSrc from "assets/images/hover/dragon-hover.png";
import comingSoonSrc from "assets/images/bubbleText/comingsoon.png";

export const ImgWrapper = styled.div`
  position: absolute;
  display: block;
  width: 32%;
  height: 36%;
  left: 19rem;
  top: 19.01rem;
  background-image: url(${dragonSrc});
  background-repeat: no-repeat;
  background-size: contain;
  cursor: pointer;
  :hover {
    background-image: url(${dragonHoverSrc});
    width: 44%;
    left: 19rem;
    top: 16.6rem;
    height: 44%;
    ::after {
      position: absolute;
      background-image: url(${comingSoonSrc});
      background-size: contain;
      display: inline-block;
      width: 40%;
      height: 35%;
      content: "";
      background-repeat: no-repeat;
      top: 0;
      right: 0;
      transform: translate(-30%, 108%);
    }
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    left: 40vw;
    top: 40vw;
    :hover{
      top: 34.75vw;
      left: 40vw;
    }
  `}
`;

export const DragonImg = styled.img`
  /* position: relative; */
  cursor: pointer;
`;
